import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import OnlineDirectoriesTable from "./view/OnlineDirectoriesTable";

const OnlineDirectories = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_digitalassets_onlinedirectories_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? (
        <OnlineDirectoriesTable />
      ) : (
        ""
      )}
    </>
  );
};

export default OnlineDirectories;
